export default __webpack_public_path__ + "static/new-ferritin__core-360-paid-01-fb78da6dde57e2cf8e1ac093f174ddca.jpg";